import React, { useState } from 'react';

import { Form } from 'form/form/Form';
import { useIam } from 'api/hooks/useIam/useIam';

import { ApproveAssetOwnerForm } from './ApproveAssetOwner.types';
import { ApproveAssetOwner } from './ApproveAssetOwner';

export const ApproveAssetOwnerContainer = () => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const { addAgent } = useIam();

  const onSubmit = async ({ ownerAddress }: ApproveAssetOwnerForm) => {
    setLoading(true);
    await addAgent(ownerAddress);
    setLoading(false);
  };

  return (
    <Form<ApproveAssetOwnerForm> shouldUnregister={false}>
      {({ handleSubmit }) => <ApproveAssetOwner onSubmit={handleSubmit(onSubmit)} isLoading={isLoading} />}
    </Form>
  );
};
